<script setup lang="ts">
import { twMerge } from "tailwind-merge";
import type { HTMLAttributes } from "vue";

const props = defineProps<{
	class?: HTMLAttributes["class"];
}>();
</script>

<template>
	<span
		:class="twMerge(
			'ml-auto pl-6 text-[0.6875rem] flex items-center tracking-wide text-muted-foreground',
			props.class
		)"
	>
		<slot />
	</span>
</template>
